import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Div, Flex } from '@fastnorth/kraken/components/layout';
import { H1, H2, Text } from '@fastnorth/kraken/components/typography';

export type RaceProgressPageHeaderProps = {
  timezoneShort?: string;
  secondsUntilUpdate?: number;
};

const RaceProgressPageHeader = ({
  timezoneShort,
  secondsUntilUpdate,
}: RaceProgressPageHeaderProps): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });

  return (
    <Flex
      className="items-start justify-between gap-4"
      data-testid="race-progress-page-header"
      spacing="3 0 3">
      <Div>
        <H1 fontWeight="semibold" size="3xl" spacing="0 0 2">
          {t('page_title')}
        </H1>
        {timezoneShort ? (
          <H2 modifier="italic" size="sm" fontWeight="body">
            {t('all_times_displayed_in', {
              eventTimezone: timezoneShort,
            })}
          </H2>
        ) : null}
      </Div>
      {secondsUntilUpdate != null ? (
        <Text aria-live="polite" size="sm">
          {t('updating_in', { seconds: secondsUntilUpdate })}
        </Text>
      ) : null}
    </Flex>
  );
};

export default RaceProgressPageHeader;
